import {getFeature} from './features.config';
import { CON_PUBLICO_NORMATIVO, CON_PUBLICO_DEM_JUD, CON_PUBLICO_PVL } from './backend-siglas.config';

export const publicMenuConfig = {
  submenus: [
    {
      id: 'analise',
      label: 'Análise',
      icon: '',
      title: 'Análise',
      items: [
        { feature: { ...getFeature('CONSULTA_PUBLICA'), name: 'Normativos', route: { url: 'consultas-publicas/normativo' }, requires: [CON_PUBLICO_NORMATIVO] } },
        { feature: { ...getFeature('CONSULTA_PUBLICA'), name: 'Demandas judiciais', route: { url: 'consultas-publicas/demanda-judicial' }, requires: [CON_PUBLICO_DEM_JUD] } },
        { feature: { ...getFeature('CONSULTA_PUBLICA'), name: 'PVL', route: { url: 'consultas-publicas/pvl' }, requires: [CON_PUBLICO_PVL] } }
      ]
    }
  ]
};

const mainMenuConfig = {
  submenus: [
    {
      id: 'configuracoes',
      label: 'Configurações',
      icon: '',
      title: 'Gerencie informações sensíveis do sistema',
      items: [
        { feature: getFeature('PREFERENCIAS')},
        { feature: getFeature('PERFIL')},
        { feature: getFeature('FINALIDADE')},
        { feature: getFeature('AUTORIDADE_EMITENTE')},
        { feature: getFeature('LISTAS')},
        { feature: getFeature('CONDICAO')},
        { feature: getFeature('LIMITE')},
        { feature: getFeature('PROGRAMA')},
        { feature: getFeature('TIPO_ANALISE')},
        { feature: getFeature('PARAMETRO_CALCULO')},
        { feature: getFeature('MODELOQUADROANALISE')},
        { feature: getFeature('ITEM_VERIFICACAO')},
        { feature: getFeature('LISTA_VERIFICACAO')},
        { feature: getFeature('CALCULOS')}
      ]
    },
    {
      id: 'cadastros',
      label: 'Cadastros',
      icon: '',
      title: 'Gerencie cadastros do sistema',
      items: [
        {feature: getFeature('ENTIDADE')},
        {feature: getFeature('USUARIOS')}
      ]
    },
    {
      id: 'analise',
      label: 'Análise',
      icon: '',
      title: 'Análise',
      items: [
        { feature: getFeature('PVL')},
        { feature: getFeature('LIMITE_SIMULACAO')},
        { feature: getFeature('CONSULTA_DOCUMENTO')},
        { feature: getFeature('NORMATIVO')},
        { feature: getFeature('DEMANDA_JUDICIAL')},
      ]
    },
    {
      id: 'cadDividaPublica',
      label: 'Cadastro da Dívida Pública',
      icon: '',
      title: 'Cadastro da Dívida Pública',
      items: [
        { feature: getFeature('COC')},
        { feature: getFeature('GARANTIA')},
        { feature: getFeature('PANORAMA')}
      ]
    }
  ]
};

export default mainMenuConfig;

export const getMenu = (idFeature) => {
  return mainMenuConfig.submenus.find(sub=>sub.items.find(i=>i.feature.id === idFeature))?.label;
};
